/* ============================================================================
   LAH — COMPARADOR DE MODELOS
   Tema: Testes de implementacao (0.8)

   Catalogo de oculos de grau: o cliente marca ate tres modelos, uma barra sobe
   e um painel os poe lado a lado.

   ============================================================================
   O QUE O PAINEL MOSTRA — e o que saiu
   ============================================================================
     foto do modelo ...... reconhecimento imediato
     nome ................ identificacao
     FOTO DE MEDIDAS ..... o visual principal
     medidas que DIFEREM . com o maior valor marcado
     medidas iguais ...... recolhidas numa linha de texto
     cores ............... cada uma leva direto a variante
     [VER PRODUTO] ....... a acao

   PRECO E AVALIACOES SAIRAM. O painel responde uma pergunta so — qual serve
   melhor no meu rosto — e os dois ja estao no cartao do catalogo, a um toque.
   Repeti-los aqui disputaria com as medidas, que sao o motivo da tela.

   As medidas iguais saem do corpo da tabela pelo mesmo motivo: comparar e
   sobre o que muda. Cinco linhas identicas em tres colunas ocupariam metade do
   painel dizendo que nao ha diferenca — uma frase resolve.

   ============================================================================
   NAO HA VENCEDOR
   ============================================================================
   O painel marca o maior de cada medida, mas nao elege um modelo. Nao sabemos
   o rosto da pessoa — eleger seria transformar uma ferramenta de decisao em
   recomendacao disfarcada.

   ============================================================================
   A SELECAO SOBREVIVE A NAVEGACAO
   ============================================================================
   Guardada em sessionStorage: quem marca dois modelos, vai para a pagina 2 do
   catalogo e marca o terceiro nao perde o que fez.
   ============================================================================ */

(function () {
    'use strict';

    var LIMITE = 3;
    var CHAVE = 'lah_comparar';

    var cartoes = document.querySelectorAll('[data-lah-cmp-toggle]');
    if (!cartoes.length) return;

    var selecao = [];

    function track(evento, dados) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: evento }, dados || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    /* ---- Persistencia ---- */
    function salvar() {
        try {
            window.sessionStorage.setItem(CHAVE, JSON.stringify(selecao));
        } catch (e) { /* segue sem lembrar entre paginas */ }
    }

    function carregar() {
        try {
            var bruto = window.sessionStorage.getItem(CHAVE);
            return bruto ? JSON.parse(bruto) : [];
        } catch (e) {
            return [];
        }
    }

    /* ---- Dados do cartao ---- */
    function dadosDoBotao(botao) {
        var cartao = botao.closest('product-item') || botao.parentElement;
        if (!cartao) return null;

        var script = cartao.querySelector('[data-lah-cmp-dados]');
        if (!script) return null;

        try {
            return JSON.parse(script.textContent);
        } catch (e) {
            return null;
        }
    }

    function indiceDe(id) {
        for (var i = 0; i < selecao.length; i++) {
            if (selecao[i].id === id) return i;
        }
        return -1;
    }

    /* =====================================================================
       BARRA
       ===================================================================== */
    var barra = null;

    function criarBarra() {
        if (barra) return barra;

        barra = document.createElement('div');
        barra.className = 'lah-cmp-barra';
        barra.innerHTML =
            '<span class="lah-cmp-barra__miniaturas" data-cmp-minis></span>' +
            '<span class="lah-cmp-barra__texto" data-cmp-texto></span>' +
            '<button type="button" class="lah-cmp-barra__limpar" data-cmp-limpar>limpar</button>' +
            '<button type="button" class="lah-cmp-barra__btn" data-cmp-abrir>Comparar</button>';

        document.body.appendChild(barra);

        barra.addEventListener('click', function (event) {
            if (event.target.closest('[data-cmp-limpar]')) {
                limparTudo();
                return;
            }

            if (event.target.closest('[data-cmp-abrir]')) {
                abrirPainel();
            }
        });

        return barra;
    }

    function pintarBarra() {
        /* A classe no body e o que faz o chat subir e descer — ver o CSS. */
        document.body.classList.toggle('lah-cmp-ativo', selecao.length > 0);

        if (!selecao.length) {
            if (barra) barra.classList.remove('is-open');
            return;
        }

        criarBarra();

        var minis = barra.querySelector('[data-cmp-minis]');
        var texto = barra.querySelector('[data-cmp-texto]');
        var botao = barra.querySelector('[data-cmp-abrir]');

        minis.innerHTML = selecao.map(function (p) {
            return '<img class="lah-cmp-barra__mini" src="' + p.imagem + '" alt="" loading="lazy">';
        }).join('');

        /* Com um modelo so nao ha o que comparar — o texto pede o segundo em vez
           de deixar o botao morto sem explicacao. */
        texto.textContent = selecao.length === 1
            ? 'Escolha mais um para comparar'
            : selecao.length + ' selecionados';

        botao.disabled = selecao.length < 2;

        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                barra.classList.add('is-open');
            });
        });
    }

    /* =====================================================================
       PAINEL
       ===================================================================== */
    var painel = null;

    var MEDIDAS = [
        { chave: 'comprimentoFrontal', rotulo: 'Comprimento frontal' },
        { chave: 'larguraLente', rotulo: 'Largura da lente' },
        { chave: 'alturaLente', rotulo: 'Altura da lente' },
        { chave: 'ponte', rotulo: 'Ponte' },
        { chave: 'haste', rotulo: 'Haste' }
    ];

    function criarPainel() {
        if (painel) return painel;

        painel = document.createElement('div');
        painel.className = 'lah-cmp-painel';
        painel.setAttribute('role', 'dialog');
        painel.setAttribute('aria-modal', 'true');

        /* O cabecalho fica DENTRO da caixa rolavel, com position sticky: assim
           ele acompanha a rolagem em vez de sair de vista, e o botao de fechar
           continua ao alcance no celular. */
        painel.innerHTML =
            '<div class="lah-cmp-painel__box">' +
            '<div class="lah-cmp-painel__head">' +
            '<h2 class="lah-cmp-painel__titulo">Comparando modelos</h2>' +
            '<button type="button" class="lah-cmp-painel__close" aria-label="Fechar" data-cmp-fechar>&times;</button>' +
            '</div>' +
            '<div data-cmp-conteudo></div>' +
            '</div>';

        document.body.appendChild(painel);

        painel.addEventListener('click', function (event) {
            if (event.target.closest('[data-cmp-fechar]') || event.target === painel) {
                fecharPainel();
            }
        });

        return painel;
    }

    function montarColuna(p, maiores) {
        var html = '<div class="lah-cmp-col">' +
            '<img class="lah-cmp-col__foto" src="' + p.imagem + '" alt="' + p.nome + '" loading="lazy">' +
            '<span class="lah-cmp-col__nome">' + p.nome + '</span>';

        if (p.medidaImagem) {
            html += '<img class="lah-cmp-col__medida-img" src="' + p.medidaImagem +
                '" alt="Medidas do ' + p.nome + '" loading="lazy">';
        }

        MEDIDAS.forEach(function (m) {
            if (maiores[m.chave] === null) return; /* igual em todos: sai da tabela */

            var valor = p.medidas[m.chave];
            if (valor === null || valor === undefined) return;

            var destaque = (valor === maiores[m.chave]) ? ' lah-cmp-linha__valor--maior' : '';

            html += '<div class="lah-cmp-linha">' +
                '<span class="lah-cmp-linha__rotulo">' + m.rotulo + '</span>' +
                '<span class="lah-cmp-linha__valor' + destaque + '">' + valor + ' mm</span>' +
                '</div>';
        });

        if (p.cores && p.cores.length) {
            html += '<span class="lah-cmp-col__cores">';
            p.cores.forEach(function (c) {
                var classe = c.disponivel ? 'lah-cmp-cor' : 'lah-cmp-cor lah-cmp-cor--esgotada';
                html += '<a class="' + classe + '" href="' + c.url + '">' + c.nome + '</a>';
            });
            html += '</span>';
        }

        html += '<span class="lah-cmp-col__cta"><a href="' + p.url + '">Ver produto</a></span>';

        return html + '</div>';
    }

    /* Para cada medida: o maior valor, ou null quando todos sao iguais — e
       nesse caso a linha nem entra na tabela. */
    function calcularMaiores(lista) {
        var maiores = {};

        MEDIDAS.forEach(function (m) {
            var valores = lista
                .map(function (p) { return p.medidas[m.chave]; })
                .filter(function (v) { return v !== null && v !== undefined; });

            if (!valores.length) {
                maiores[m.chave] = null;
                return;
            }

            var min = Math.min.apply(null, valores);
            var max = Math.max.apply(null, valores);

            maiores[m.chave] = (min === max) ? null : max;
        });

        return maiores;
    }

    function abrirPainel() {
        if (selecao.length < 2) return;

        criarPainel();

        var maiores = calcularMaiores(selecao);

        var html = '<div class="lah-cmp-grade" data-qtd="' + selecao.length + '">' +
            selecao.map(function (p) { return montarColuna(p, maiores); }).join('') +
            '</div>';

        var iguais = MEDIDAS.filter(function (m) {
            return maiores[m.chave] === null && selecao[0].medidas[m.chave];
        });

        if (iguais.length) {
            var nomes = iguais.map(function (m) {
                return m.rotulo.toLowerCase() + ' (' + selecao[0].medidas[m.chave] + ' mm)';
            });

            html += '<p class="lah-cmp-iguais">Iguais nos ' +
                (selecao.length === 2 ? 'dois' : 'três') + ' modelos: ' +
                nomes.join(', ') + '.</p>';
        }

        painel.querySelector('[data-cmp-conteudo]').innerHTML = html;
        painel.classList.add('is-open');
        document.body.classList.add('hidden-scroll');

        track('comparador_aberto', {
            modelos: selecao.map(function (p) { return p.nome; }).join(' | '),
            quantidade: selecao.length
        });
    }

    function fecharPainel() {
        if (!painel) return;
        painel.classList.remove('is-open');
        document.body.classList.remove('hidden-scroll');
    }

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && painel && painel.classList.contains('is-open')) {
            fecharPainel();
        }
    });

    /* =====================================================================
       SELECAO
       ===================================================================== */
    function sincronizarCartoes() {
        Array.prototype.forEach.call(cartoes, function (botao) {
            var dados = dadosDoBotao(botao);
            if (!dados) return;

            var marcado = indiceDe(dados.id) !== -1;
            botao.setAttribute('aria-pressed', marcado ? 'true' : 'false');
        });

        document.body.classList.toggle('lah-cmp-cheio', selecao.length >= LIMITE);
    }

    function limparTudo() {
        selecao = [];
        salvar();
        sincronizarCartoes();
        pintarBarra();
        track('comparador_limpo', {});
    }

    Array.prototype.forEach.call(cartoes, function (botao) {
        botao.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            var dados = dadosDoBotao(botao);
            if (!dados) return;

            var i = indiceDe(dados.id);

            if (i !== -1) {
                selecao.splice(i, 1);
            } else {
                if (selecao.length >= LIMITE) return;
                selecao.push(dados);
                track('comparador_selecionado', { modelo: dados.nome });
            }

            salvar();
            sincronizarCartoes();
            pintarBarra();
        });
    });

    /* =====================================================================
       INICIO

       A selecao guardada pode conter modelos que nao estao nesta pagina — quem
       marcou na pagina 1 e foi para a 2. Mantemos todos: o painel funciona com
       os dados guardados, e as caixas visiveis apenas refletem quem esta aqui.
       ===================================================================== */
    selecao = carregar().filter(function (p) {
        return p && p.id && p.medidas;
    }).slice(0, LIMITE);

    sincronizarCartoes();
    if (selecao.length) pintarBarra();
})();
